import EditIcon from "@mui/icons-material/Edit";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import HistoryIcon from "@mui/icons-material/History";
import LoupeIcon from "@mui/icons-material/Loupe";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import {PuiGrid, PuiSearchPage, PuiTableAction} from "@portnet/ui";
import download from "downloadjs";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {generatePath, useNavigate} from "react-router-dom";
import AppAutocomplete from "../../../../common/components/inputs/AppAutocomplete";
import AppDateField from "../../../../common/components/inputs/AppDateField";
import AppSelect from "../../../../common/components/inputs/AppSelect";
import AppSimpleReferentielField from "../../../../common/components/inputs/AppSimpleReferentielField";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppButton from "../../../../common/components/ui/AppButton";
import {DETAIL_SOUSCRIPTION_PAGE_ROUTE} from "../../../../common/constants/routerConstants";
import useLocalReferentiel from "../../../../common/hooks/useLocalReferentiel";
import usePagination from "../../../../common/hooks/usePagination";
import * as localReferentielKeys from "../../../../common/localReferentiel/others/localReferentielKeys";
import {formatDataForSearch} from "../../../../common/utils/helpers";
import HistoriqueSouscription from "../../historiqueSouscription/page/HistoriqueSouscription";
import ModificationSouscriptionPage from "../../modificationSouscription/page/ModificationSouscriptionPage";
import * as consultationSouscriptionFormNames from "../others/consultationSouscriptionsFormNames";
import {consultationSouscriptionInitialValues} from "../others/consultationSouscriptionsInitialValues";
import {consultationSouscriptionTableColumns} from "../others/consultationSouscriptionsTableColumns";
import {consultationSouscriptionValidationSchema} from "../others/consultationSouscriptionsValidationSchemas";
import {
  excelExport,
  getConsultationSouscriptionsListAction,
  printReinitialization,
} from "../state/consultationSouscriptionsActions";
import * as consultationTransactionsFormNames
  from "../../../transactions/consultationTransactions/others/consultationTransactionsFormNames";
import AppSpecificReferentielField from "../../../../common/components/inputs/AppSpecificReferentielField";
import AppSimplePopupReferentielField from "../../../../common/components/inputs/AppSimplePopupReferentielField";

const ConsultationSouscriptionsPage = ({ type }) => {
  const getPageTitleElementsByType = (type) => {
    return {
      title:
        type === "consultation"
          ? "Consultation des souscriptions"
          : type === "gestion"
          ? "Gestion des souscriptions"
          : "",
      icon:
        type === "consultation" ? (
          <FormatListBulletedIcon />
        ) : type === "gestion" ? (
          <ManageSearchIcon />
        ) : (
          ""
        ),
      trace:
        type === "consultation"
          ? ["Accueil", "Consultation des souscriptions"]
          : type === "gestion"
          ? ["Accueil", "Gestion des souscriptions"]
          : undefined,
    };
  };

  const actionsColumn = {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => (
        <>
          {tableActions.map((action, index) => {
            if (action.props.hideFunc && action.props.hideFunc(row)) {
              return null;
            }

            return React.cloneElement(action, { key: index, row: row });
          })}
        </>
    ),
  };


  const NavigationActions = () => {
    return (
      <PuiGrid container>
        <PuiGrid item>
          <AppButton
            loading={isFileToPrintLoading}
            disabled={isConsultationSouscriptionsListLoading}
            loadingPosition="start"
            startIcon={<FileDownloadIcon />}
            color="tertiary"
            onClick={excelExportHandler}
          >
            Exporter
          </AppButton>
        </PuiGrid>
      </PuiGrid>
    );
  };

  const { user } = useSelector((state) => state.auth.login);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [paginationState, changePage] = usePagination(10);



  const [OperateurField, setOperateurField] = React.useState(
      <AppTextField label="Opérateur" disabled />
  );

  const formRef = React.useRef();

  const {
    content: fileToPrintContent,
    type: fileToPrintType,
    fileName: fileToPrintName,
    isLoading: isFileToPrintLoading,
    isSuccessed: isFileToPrintSuccessed,
    hasError: hasFileToPrintError,
  } = useSelector(
    (state) => state.souscription.consultationSouscriptions.print
  );
  const {
    content: consultationSouscriptionsList,
    totalElements: consultationSouscriptionsListTotalElements,
    isLoading: isConsultationSouscriptionsListLoading,
  } = useSelector(
    (state) =>
      state.souscription.consultationSouscriptions.consultationSouscriptionsList
  );

  const excelExportHandler = () => {
    const searchData = formatDataForSearch(
      filtersState,
      {
        page: 0,
        size: 500,
      },
      {
        direction: "DESC",
        sortField: "id",
      }
    );
    dispatch(excelExport(searchData));
  };

  let modifiedColumns = user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF")
      ? [...consultationSouscriptionTableColumns, actionsColumn]
      : consultationSouscriptionTableColumns.filter(column => column.field !== "roleOperateur").concat(actionsColumn);

  const roleOperateurChangeHandler = (roleOperateur) => {
    formRef?.current.setFieldValue(
        consultationTransactionsFormNames.OPERATEUR_FORM_NAME,
        ""
    );
    const roleOperateurCode = roleOperateur?.code;
    let InputToRender;
    switch (roleOperateurCode) {
      case "ROLE_VUPORTUARIA_CONSIGNATARIO":
        InputToRender = (
            <AppSpecificReferentielField
                title="Recherche de consignataires"
                searchKey="CONSIGNATAIRES"
                label="Consignataire"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_OPERADOR":
        InputToRender = (
            <AppSpecificReferentielField
                title="Recherche d'opérateurs"
                searchKey="OPERATEURS_MANUTENTION"
                label="Opérateur"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_ANP":
        InputToRender = (
            <AppSimplePopupReferentielField
                title="Recherche de ports"
                searchKey="LISTE_PORTS"
                label="Port"
                descriptionLabel="Nom"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_TRANSITARIO":
        InputToRender = (
            <AppSpecificReferentielField
                title="Recherche de transitaires"
                searchKey="TRANSITAIRES"
                label="Transitaire"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_IMPORTADOR":
        InputToRender = (
            <AppSpecificReferentielField
                title="Recherche d'importateurs"
                searchKey="OPERATEURS_IMP_EXP"
                label="Importateur"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      case "ROLE_VUPORTUARIA_BANCO":
        InputToRender = (
            <AppSimplePopupReferentielField
                title="Recherche de banques"
                searchKey="LISTE_BANQUES"
                descriptionLabel="Banque"
                label="Banque"
                getRenderedValue={(row) => row.description}
                getReturnedValue={(row) => row.id}
            />
        );
        break;
      default:
        InputToRender = <AppTextField label="Opérateur" disabled />;
        break;
    }
    setOperateurField(InputToRender);
  };

  const { isSuccessed: isModificationSouscriptionSuccessed } = useSelector(
    (state) =>
      state.souscription.modificationSouscription.envoiModificationSouscription
  );

  const [pageTitleElements, setPageTitleElements] = React.useState({
    title: "",
    icon: <></>,
    trace: [],
  });

  const [filtersState, setFiltersState] = React.useState({
    ...consultationSouscriptionInitialValues,
  });

  const [
    codePackagesOptions,
    rolesOperateurOptions,
    statutSouscriptionOptions,
    exerciceSouscriptionOptions,
    portSouscriptionOptions,
  ] = useLocalReferentiel([
    localReferentielKeys.CODES_PACKAGES_LOCAL_REFERENTIEL_KEY,
    localReferentielKeys.ROLES_OPERATEUR_LOCAL_REFERENTIEL_KEY,
    localReferentielKeys.STATUS_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY,
    localReferentielKeys.EXERCICE_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY,
    localReferentielKeys.PORT_SOUSCRIPTION_LOCAL_REFERENTIEL_KEY,
  ]);

  const navigateToDetail = (row) => {
    navigate(
      generatePath(DETAIL_SOUSCRIPTION_PAGE_ROUTE, {
        id: row,
      })
    );
  };

  const [openHistorique, setOpenHistorique] = React.useState(false);
  const [selectedSouscription, setSelectedSouscription] = React.useState();
  const [openSouscriptionModification, setOpenSouscriptionModification] =
    React.useState(false);

  const tableActions = React.useMemo(
    () => [
      <PuiTableAction
        title="Détails"
        onClick={(row) => {
          navigateToDetail(row.id);
        }}
        color="primary"
      >
        <LoupeIcon style={{ color: 'fuchsia' }} />
      </PuiTableAction>,

      <PuiTableAction
        title="Historique"
        onClick={(row) => {
          setOpenHistorique(true);
          setSelectedSouscription(row);
        }}
      >
        <HistoryIcon style={{ color: 'orange' }} />
      </PuiTableAction>,
      <PuiTableAction
        title="Gestion"
        hide={type === "consultation"}
        onClick={(row) => {
          setOpenSouscriptionModification(true);
          setSelectedSouscription(row);
        }}
      >
        <EditIcon />
      </PuiTableAction>,
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [type]
  );

  const pageChangeHandler = (pageNumber) => {
    changePage(pageNumber);
  };


  const submitHandler = (values) => {
    const searchData = formatDataForSearch(
        values,           // Filters (form values)
        {
          page: paginationState.page,   // Current page
          size: paginationState.size >= 1 ? paginationState.size : 10, // Ensure pageSize is valid
        },
        {
          direction: "DESC",  // Sorting direction
          sortField: "id",     // Sort field
        }
    );

    dispatch(getConsultationSouscriptionsListAction(searchData));
    // Update the filter state to reflect changes in the UI
    setFiltersState(values);
  };

  const roleCodeMapping = {
    "ROLE_VUPORTUARIA_BANCO": "BNK",
    "ROLE_VUPORTUARIA_IMPORTADOR": "IMP",
    "ROLE_VUPORTUARIA_OPERADOR": "OPM",
    "ROLE_VUPORTUARIA_ANP": "ANP",
    "ROLE_VUPORTUARIA_TRANSITARIO": "TRA",
    "ROLE_VUPORTUARIA_CONSIGNATARIO": "AGM",
  };
  const filterByRole = (row) => {
    return user.roles.some(role => {
      const codeSnippet = roleCodeMapping[role];
      return codeSnippet && row.code && row.code.includes(codeSnippet);
    });
  };

  const filteredOptions = React.useMemo(() => {
    let content = codePackagesOptions.content;
    if (user && user.roles && user.roles.length > 0 && !user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") && !user.roles.includes("ROLE_VUPORTUARIA_ADMIN")&&!user.roles.includes("ROLE_VUPORTUARIA_USER_MANAGER")) {
      return content.filter(filterByRole);
    }
    return content;
  }, [codePackagesOptions.content, user.roles]);

  React.useEffect(() => {
    setPageTitleElements(getPageTitleElementsByType(type));
  }, [type]);

  React.useEffect(() => {
    const searchData = formatDataForSearch(filtersState, paginationState, {
      direction: "DESC",
      sortField: "id",
    });
    const token = sessionStorage.getItem('token');

    dispatch(getConsultationSouscriptionsListAction(searchData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersState, paginationState]);

  React.useEffect(() => {
    if (isModificationSouscriptionSuccessed) {
      const searchData = formatDataForSearch(filtersState, paginationState, {
        direction: "DESC",
        sortField: "id",
      });
      dispatch(getConsultationSouscriptionsListAction(searchData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModificationSouscriptionSuccessed]);

  React.useEffect(() => {
    if (hasFileToPrintError) {
      dispatch(printReinitialization());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasFileToPrintError]);

  React.useEffect(() => {
    if (isFileToPrintSuccessed) {
      console.log("fileToPrintContent", fileToPrintContent);
      download(
        `data:${`${fileToPrintType.type}/${fileToPrintType.subtype}`};base64,${fileToPrintContent}`,
        fileToPrintName,
        `${fileToPrintType.type}/${fileToPrintType.subtype}`
      );
      dispatch(printReinitialization());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFileToPrintSuccessed]);

  return (
    <PuiSearchPage
      formik
      formikProps={{
        initialValues: consultationSouscriptionInitialValues,
        validationSchema: consultationSouscriptionValidationSchema,
        innerRef: formRef,
        onSubmit: submitHandler,
      }}
      title={pageTitleElements.title}
      titleIcon={pageTitleElements.icon}
      trace={pageTitleElements.trace}
      navActions={<NavigationActions />}
      topNav
      retour={false}
      tableProps={{
        columns: modifiedColumns,
        rows: consultationSouscriptionsList,
        rowCount: consultationSouscriptionsListTotalElements,
        loading: isConsultationSouscriptionsListLoading,
        actions: [],
        page: paginationState.page,
        pageSize: paginationState.size,
        onPageChange: pageChangeHandler,
      }}
    >
      <PuiGrid container>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppTextField
            label="Identifiant de la souscription"
            name={
              consultationSouscriptionFormNames.IDENTIFIANT_SOUSCRIPTION_FORM_NAME
            }
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppAutocomplete
            label="Code package"
            name={consultationSouscriptionFormNames.CODE_PACKAGE_FORM_NAME}
            options={filteredOptions}
            loading={codePackagesOptions.isLoading}
            error={codePackagesOptions.hasError}
            helperText={codePackagesOptions.error}
            getOptionLabel={(row) => row.code}
            getOptionValue={(row) => row.code}
          />
        </PuiGrid>
        {(user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") || user.roles.includes("ROLE_VUPORTUARIA_ADMIN")|| user.roles.includes("ROLE_VUPORTUARIA_USER_MANAGER")) && (
            <>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppAutocomplete
              label="Rôle de l'opérateur"
              name={
                consultationTransactionsFormNames.ROLE_OPERATEUR_FORM_NAME
              }
              options={rolesOperateurOptions.content}
              loading={rolesOperateurOptions.isLoading}
              error={rolesOperateurOptions.hasError}
              helperText={rolesOperateurOptions.error}
              getOptionLabel={(option) => option.description}
              getOptionValue={(option) => option.id}
              onChange={roleOperateurChangeHandler}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={4} md={4}>
          {React.cloneElement(OperateurField, {
            name: consultationTransactionsFormNames.OPERATEUR_FORM_NAME,
          })}
        </PuiGrid>
            </>
        )}
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppSimpleReferentielField
            autocomplete
            searchKey="LISTE_PAIEMENT_PACKAGE"
            label="Type de paiement"
            name={consultationSouscriptionFormNames.TYPE_PAIEMENT_FORM_NAME}
            getOptionLabel={(option) => option.description}
            getOptionValue={(option) => option.code}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppSimpleReferentielField
            autocomplete
            searchKey="LISTE_TRANSACTIONS_AUTORISEES"
            label="Transaction autorisée"
            name={
              consultationSouscriptionFormNames.TRANSACTION_AUTORISEE_FORM_NAME
            }
            getOptionLabel={(option) => option.description}
            getOptionValue={(option) => option.code}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppSimpleReferentielField
            autocomplete
            searchKey="LISTE_STATUS_PACKAGE"
            label="Statut du package"
            name={consultationSouscriptionFormNames.STATUS_PACKAGE_FORM_NAME}
            getOptionLabel={(option) => option.description}
            getOptionValue={(option) => option.code}
            filterFunc={(option) => option.code !== "DELETED"}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppDateField
            label="Du (Date fin de validité)"
            name={consultationSouscriptionFormNames.VALIDITE_DU_FORM_NAME}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppDateField
            label="Au (Date fin de validité)"
            name={consultationSouscriptionFormNames.VALIDITE_AU_FORM_NAME}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={4} md={4}>
          <AppSelect
            label="Statut de la souscription"
            name={
              consultationSouscriptionFormNames.STATUS_SOUSCRIPTION_FORM_NAME
            }
            options={statutSouscriptionOptions.content}
            loading={statutSouscriptionOptions.isLoading}
            error={statutSouscriptionOptions.hasError}
            helperText={statutSouscriptionOptions.error}
            getOptionLabel={(option) => option.description}
            getOptionValue={(option) => option.code}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={6} md={3}>
          <AppDateField
            label="Du (Date de souscription)"
            name={
              consultationSouscriptionFormNames.DEBUT_DATE_SOUSCRIPTION_FORM_NAME
            }
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={6} md={3}>
          <AppDateField
            label="Au (Date de souscription)"
            name={
              consultationSouscriptionFormNames.FIN_DATE_SOUSCRIPTION_FORM_NAME
            }
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={6} md={3}>
          <AppSelect
            label="Exercice"
            name={
              consultationSouscriptionFormNames.EXERCICE_SOUSCRIPTION_FORM_NAME
            }
            options={exerciceSouscriptionOptions.content}
            loading={exerciceSouscriptionOptions.isLoading}
            error={exerciceSouscriptionOptions.hasError}
            helperText={exerciceSouscriptionOptions.error}
            getOptionLabel={(option) => option.description}
            getOptionValue={(option) => option.code}
          />
        </PuiGrid>
        <PuiGrid item xs={12} sm={6} md={3}>
          <AppSelect
            label="Port"
            name={consultationSouscriptionFormNames.PORT_SOUSCRIPTION_FORM_NAME}
            options={portSouscriptionOptions.content}
            loading={portSouscriptionOptions.isLoading}
            error={portSouscriptionOptions.hasError}
            helperText={portSouscriptionOptions.error}
            getOptionLabel={(option) => option.description}
            getOptionValue={(option) => option.code}
          />
        </PuiGrid>
      </PuiGrid>
      {openHistorique && (
        <HistoriqueSouscription
          open={openHistorique}
          close={() => setOpenHistorique(false)}
          selected={selectedSouscription}
        />
      )}
      {openSouscriptionModification && (
        <ModificationSouscriptionPage
          open={openSouscriptionModification}
          close={() => setOpenSouscriptionModification(false)}
          selected={selectedSouscription}
        />
      )}
    </PuiSearchPage>
  );
};

export default ConsultationSouscriptionsPage;
